import * as React from 'react';
import * as styles from './styles.css';

export function Layout({ children, stretch }: React.PropsWithChildren<{ stretch?: boolean }>) {
  return <div className={stretch ? styles['stretch'] : styles['container']}>{children}</div>;
}
